import {toast} from 'react-toastify'

const LOGIN_TIMEOUT_MS = 1000 * 30

export const LOGIN_TIMEOUT_MESSAGE =
  'Login is taking longer than expected. Please check your internet connection and try again.'

type LoginTimeoutHandlers = {
  setLoading?: (loading: boolean) => void
  setSubmitting?: (isSubmitting: boolean) => void
  setStatus?: (status: string) => void
}

/**
 * The login APIs have no client-side timeout: a hung backend used to leave the
 * form stuck on "Please wait..." or silently reload the page after 30s, which
 * users read as a mystery refresh (seen when a tenant DB maxed out its CPU).
 * Instead, surface the stall as a visible error and re-enable the form. The
 * request is left in flight on purpose — a late success can still navigate,
 * and a late failure just replaces the message.
 *
 * Returns a cancel function; call it in both the success and failure callbacks.
 */
export const armLoginTimeout = (handlers: LoginTimeoutHandlers) => {
  const timeout = setTimeout(() => {
    handlers.setLoading?.(false)
    handlers.setSubmitting?.(false)
    if (handlers.setStatus) {
      handlers.setStatus(LOGIN_TIMEOUT_MESSAGE)
    } else {
      toast.error(LOGIN_TIMEOUT_MESSAGE)
    }
  }, LOGIN_TIMEOUT_MS)

  return () => clearTimeout(timeout)
}
